import React from 'react'

import { withTranslation } from 'react-i18next/hooks'
import { LangUtil } from './LangUtil';

//export default 
class DevTools_ extends React.Component {



    render() {

        return (
            <>
                <LangUtil></LangUtil>
            </>
        )
    }

}

export const DevTools = withTranslation()(DevTools_);